import React from 'react';
import * as S from '../ExternalDataTabs.styles';

interface HudleServersTabProps {
  data: Record<string, any>;
}

export const HudleServersTab: React.FC<HudleServersTabProps> = ({ data }) => {
  const servers = data.servers || [];

  const formatDate = (dateString?: string) => {
    if (!dateString) return '—';
    try {
      return new Date(dateString).toLocaleString('ru-RU');
    } catch {
      return dateString;
    }
  };

  if (servers.length === 0) {
    return <S.EmptyState>Нет данных о серверах</S.EmptyState>;
  }

  return (
    <div>
      <S.SectionTitle>Сервера ({servers.length})</S.SectionTitle>
      {servers.map((server: any, index: number) => (
        <S.ListItem key={index}>
          <S.ListItemTitle>{server.server_name || 'Без названия'}</S.ListItemTitle>
          <S.InfoRow>
            <S.InfoLabel>ID сервера</S.InfoLabel>
            <S.InfoValue>{server.server_id || '—'}</S.InfoValue>
          </S.InfoRow>
          <S.InfoRow>
            <S.InfoLabel>Приватный</S.InfoLabel>
            <S.InfoValue>
              <S.Badge $variant={server.is_private ? 'warning' : 'success'}>
                {server.is_private ? 'Да' : 'Нет'}
              </S.Badge>
            </S.InfoValue>
          </S.InfoRow>
          <S.InfoRow>
            <S.InfoLabel>Владелец ID</S.InfoLabel>
            <S.InfoValue>{server.owner_id || '—'}</S.InfoValue>
          </S.InfoRow>
          <S.InfoRow>
            <S.InfoLabel>Создан</S.InfoLabel>
            <S.InfoValue>{formatDate(server.server_created_at)}</S.InfoValue>
          </S.InfoRow>
          {server.user_access && (
            <>
              <S.InfoRow>
                <S.InfoLabel>Присоединился</S.InfoLabel>
                <S.InfoValue>{formatDate(server.user_access.joined_at)}</S.InfoValue>
              </S.InfoRow>
              {server.user_access.kicked_at && (
                <S.InfoRow>
                  <S.InfoLabel>Кикнут</S.InfoLabel>
                  <S.InfoValue>
                    <S.Badge $variant="error">
                      {formatDate(server.user_access.kicked_at)}
                    </S.Badge>
                  </S.InfoValue>
                </S.InfoRow>
              )}
            </>
          )}
          {server.profile && (
            <>
              <S.InfoRow>
                <S.InfoLabel>Никнейм на сервере</S.InfoLabel>
                <S.InfoValue>{server.profile.nickname || '—'}</S.InfoValue>
              </S.InfoRow>
            </>
          )}
          {server.roles && server.roles.length > 0 && (
            <>
              <S.InfoRow>
                <S.InfoLabel>Роли ({server.roles.length})</S.InfoLabel>
                <S.InfoValue>
                  {server.roles.map((role: any, idx: number) => (
                    <S.Badge key={idx} $variant={role.is_owner_role ? 'warning' : 'info'} style={{ marginRight: '4px' }}>
                      {role.role_name}
                    </S.Badge>
                  ))}
                </S.InfoValue>
              </S.InfoRow>
            </>
          )}
          {server.server_ban && (
            <>
              <S.InfoRow>
                <S.InfoLabel>Забанен на сервере</S.InfoLabel>
                <S.InfoValue>
                  <S.Badge $variant="error">Да</S.Badge>
                </S.InfoValue>
              </S.InfoRow>
              <S.InfoRow>
                <S.InfoLabel>Причина бана</S.InfoLabel>
                <S.InfoValue>{server.server_ban.reason || '—'}</S.InfoValue>
              </S.InfoRow>
            </>
          )}
        </S.ListItem>
      ))}
    </div>
  );
};

